module.exports = __webpack_public_path__ + "static/media/logo-footer-new.036a456b.png";